export class EntityOption {
    type: string = '';
    path: string = '';
    name: string = '';
    shown: boolean = false;
}
